import React from 'react'
import ReactDOM from 'react-dom/client'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { withFaroRouterInstrumentation } from '@grafana/faro-react'

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { AmbassadorProvider } from '@context/context'
import NotificationWrapper from '@corecomponents/notification/NotificationWrapper'
import { initFaro } from 'faro'

initFaro()

const queryClient = new QueryClient()

const reactRouter = createBrowserRouter(
  createRoutesFromElements(<Route path="*" element={<App />} />)
)

const router = withFaroRouterInstrumentation(reactRouter)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AmbassadorProvider>
        <RouterProvider router={router} />
      </AmbassadorProvider>
    </QueryClientProvider>
  </React.StrictMode>
)

reportWebVitals()
